// extracted by mini-css-extract-plugin
module.exports = {"employers__carousel":"styles_employers__carousel__hdjA6","employers__footer":"styles_employers__footer__WeK7c","employers__link":"styles_employers__link__FFu_A"};